import styled from 'styled-components';

export default styled.section`
	padding: 0 0 var(--px-5) 0;
	margin-bottom: var(--px-20);
	max-height: var(--px-1110);
	@media only screen and (min-width: 1280px) and (max-width: 1366px) {
		max-height: var(--px-1140);
	}
	overflow-y: auto;
	.motif-accordion {
		&:first-child {
			margin-top: 0 !important;
		}
		&.noChildrenAvailable {
			border-radius: var(--border-radius-medium) var(--border-radius-medium) 0 0;
			& + .StyledBodySpecialListItemNoDataPlaceholder {
				border-radius: 0 0 var(--border-radius-medium) var(--border-radius-medium);
			}
		}
	}
	&.isa315-itprocess-task-list {
		height: 100%;
		min-height: inherit;
		.motif-accordion {
			.motif-accordion-content {
				.StyledBodySpecialAccordionContentList {
					padding: var(--px-10) var(--px-17) var(--px-10) var(--px-43);
					.itprocess-task-related-task-list-item {
						border-top: var(--px-1) solid var(--neutrals-200);
					}
				}
			}
		}
		.BodySpecialListItemNoDataPlaceholder {
			padding-left: var(--px-46);
			.no-data-placeholder {
				a {
					font-weight: bold;
				}
			}
		}
		.StyledBodySpecialAccordionHeader {
			.StyledBodySpecialAccordionHeaderColumn:first-child {
				.body-special-accordion-header-column-value {
					max-width: var(--px-1170) !important;
				}
			}
		}
	}
	&.isa315-itapp-scot-body-itapp-list {
		.StyledBodySpecialAccordionHeader {
			.StyledBodySpecialAccordionHeaderColumn:first-child {
				.body-special-accordion-header-column-value {
					max-width: var(--px-1020) !important;
				}
			}
		}
	}
	.isa315-scot-itapplication-body-list {
		border: solid 1px solid;
		.StyledBodySpecialAccordionHeader {
			.StyledBodySpecialAccordionHeaderColumn:first-child {
				.body-special-accordion-header-column-value {
					max-width: var(--px-750) !important;
				}
			}
		}
	}
	&.isa315-itprocess-itrisk-list {
		.StyledBodySpecialAccordionHeader {
			.StyledBodySpecialAccordionHeaderColumn:first-child {
				.body-special-accordion-header-column-value {
					max-width: var(--px-830) !important;
				}
			}
		}
	}
`;
